/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Eon snapshot.
*/
export class JobSnapshotDetails {
  /**
  * Snapshot ID.
  */
  'id'?: string;
  /**
  * Date and time of the resource that\'s preserved by the snapshot.
  */
  'pointInTime': Date;
  /**
  * Date and time the snapshot\'s retention is expected to expire, after which it\'s marked for deletion.
  */
  'expirationTime'?: Date;
  /**
  * The backup retention in days
  */
  'backupRetention'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "pointInTime",
      "baseName": "pointInTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "expirationTime",
      "baseName": "expirationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "backupRetention",
      "baseName": "backupRetention",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return JobSnapshotDetails.attributeTypeMap;
  }

  public constructor() {
  }
}

